import { createFileRoute } from '@tanstack/react-router'

import ProjectReport from 'pages/ProjectReport'

export const Route = createFileRoute('/_auth/projects/$id/report')({
  component: ProjectReport,
})
